import React from "react";
import { AlertBlock } from "../AlertBlock";
import { AlertBlockProps } from "../AlertBlock/AlertBlock";

export interface APIErrorProps extends Partial<Omit<AlertBlockProps, "title">> {
  title?: string;
}

/**
 * A customisation of the alert component specifically for use when APIs fail to return data required for a component
 * @param title - Main title describing the information unable to be retrieved from this API
 * @param messages - Additional messages to be displayed detailing the error
 * @param props - Further props to customise the underlying AlertBlock
 */
export const APIError: React.FC<APIErrorProps> = ({
  title,
  messages = [],
  ...props
}) => (
  <AlertBlock
    {...props}
    isClosable={false}
    variant="error"
    title={title}
    messages={[...messages, "Please try again later."]}
  />
);
